export const AoaSuperType = 'Anvil of Apotheosis';
export var AnvilWeaponModType;
(function (AnvilWeaponModType) {
    // "Your hero’s Warpforged Blade has Crit (Mortal)."
    AnvilWeaponModType[AnvilWeaponModType["ApplyAll"] = 1] = "ApplyAll";
    // "Your hero’s Warpforged Blade has Anti-X (+1 Rend), where X is l of the following keywords: INFANTRY, CAVALRY, MONSTER, WAR MACHINE, WIZARD or PRIEST."
    AnvilWeaponModType[AnvilWeaponModType["PickOne"] = 2] = "PickOne";
})(AnvilWeaponModType || (AnvilWeaponModType = {}));
